import { useMemo } from "react";
import { fromUnixTime, getUnixTime } from "date-fns/esm";

import { DATA_RANGE_DAYS, SECONDS_PER_DAY } from "./constants";

// Counted in UTC seconds: a local midnight drifts across DST and breaks the API's 31 * 24h cap
const useDoraDateRange = () => {
  return useMemo(() => {
    const todayStart = Math.floor(getUnixTime(new Date()) / SECONDS_PER_DAY) * SECONDS_PER_DAY;

    return {
      startTime: fromUnixTime(todayStart - DATA_RANGE_DAYS * SECONDS_PER_DAY),
      endTime: fromUnixTime(todayStart + SECONDS_PER_DAY - 1),
    };
  }, []);
};

export default useDoraDateRange;
